import {Checkbox} from '@mantine/core'

type QuoteLinePeriodBasisProps = {
    basis: string
    checked: boolean
    disabled: boolean
    onChange: (checked: boolean) => void
}

export function QuoteLinePeriodBasis({
    basis,
    checked,
    disabled,
    onChange,
}: QuoteLinePeriodBasisProps) {
    return (
        <Checkbox
            size="xs"
            label={basis}
            title="Price this line for the whole rental period"
            aria-label="Price for the rental period"
            checked={checked}
            disabled={disabled}
            onChange={(event) => onChange(event.currentTarget.checked)}
        />
    )
}
